import React,{lazy,Suspense} from 'react'
import './Externo.scss'
import { useState,useEffect } from 'react'
import * as funsiones from './funsionesexterno'


import Cargando from './Cargando'
import Caducado from './Caducado'
const Visor = lazy(() => import('../NuevoVisor/Visor'));
function Externo(props) {
    const [Listo,setListo]=useState({listo:false,acceso:false,estudio:null})
    let contenido
    useEffect(() => {
        funsiones.acceso(props.match.params.token)
        .then((res)=>{
            console.log(res)
            if(res.estado){
                setListo({listo:true,acceso:true,estudio:res.estudio})
            }else{
                setListo({listo:true,acceso:false})
            }
        })
        return () => {
            console.log('cerando')
        }
    }, [])
    if(Listo.listo){
        if(Listo.acceso){
            contenido=<Suspense fallback={<div>Cargando...</div>}><Visor estudio={Listo.estudio}/></Suspense>
        }else{
            contenido=<Caducado/>
        }
    }else{
        contenido=<Cargando/>
    }
    return (
        <div id="Externo">
            {contenido}
        </div>
    )
}
export default Externo
